import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Ban } from 'lucide-react';
import { ErrorState } from '../../../components/ui/ErrorState';
import { taskEntered } from '../../../features/operator/operatorDeviceSlice';
import { OPERATOR_FLOW_LABELS, OPERATOR_SCREEN } from '../../../features/operator/operatorConstants';
import { inactiveCompanies } from '../../../features/operator/operatorUtils';

/**
 * A flow this warehouse does not let the operator work, and why: the module
 * off for a company, or the flow off for the role. Three different things,
 * fixed in three different places. A screen of its own: what answers for the
 * task left behind is named after it, as anywhere else.
 *
 * @param {object} props
 * @param {string} props.flow
 * @param {object} props.warehouse
 */
export const FlowUnavailable = ({ flow, warehouse }) => {
  const dispatch = useDispatch();
  const reasons = inactiveCompanies(warehouse);

  useEffect(() => {
    dispatch(taskEntered({ flow: OPERATOR_SCREEN.FLOW_UNAVAILABLE, taskId: flow }));
  }, [dispatch, flow]);

  return (
    <div data-testid="flow-unavailable" data-flow={flow} className="space-y-4">
      <ErrorState
        icon={Ban}
        title={`${OPERATOR_FLOW_LABELS[flow]} no está disponible en ${warehouse.name}`}
        description="Tu supervisor puede revisarlo con NinjaHubs."
      />
      {reasons.length > 0 && (
        <ul className="divide-y divide-border rounded-2xl border border-border bg-white dark:bg-[#1a1a1a]">
          {reasons.map((reason) => (
            <li key={reason.name} className="px-4 py-3 text-sm">
              <p className="font-semibold text-ninja-dark dark:text-white">
                {reason.name}: {reason.label}
              </p>
              {reason.hint && <p className="text-text-secondary">{reason.hint}</p>}
            </li>
          ))}
        </ul>
      )}
      <Link
        to="/dashboard"
        className="block rounded-xl border border-border px-4 py-3 text-center font-semibold text-ninja-dark dark:text-white"
      >
        Volver al inicio
      </Link>
    </div>
  );
};
